<template>
  <div v-show="messages.length">
    <!--<CAlert :color="item.status"  :show.sync="currentAlertCounter" v-for="(item, i) in messages"  closeButton :key="i">
      {{ item.text }}
    </CAlert>-->
    <CAlert :color="item.status" closeButton :show.sync="currentAlertCounter" :key="i" v-for="(item, i) in messages">
      <center>
        <strong>{{ item.text }}</strong>
      </center>
      <CProgress v-if="showProgress" :max="5" :value="currentAlertCounter" height="3px" :color="item.status" animate />
    </CAlert>
  </div>
</template>

<script>
export default {
  name: 'MenssageAlert',
  props: {
    messages: {
      type: Array,
      required: true,
    },
    showProgress: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      currentAlertCounter: 5,
    }
  },
  watch: {
    messages: {
      handler() {
        this.currentAlertCounter = 5
      },
    },
  },
}
</script>

<style></style>
